import React from 'react';
import svgElementClickableListener from '../../../hoc/svgElementClickableListener';
import RectComponent from './Rect';
import CircleComponent from './Circle';
import PolygonComponent from './Polygon';
import PathComponent from './Path';
import LineComponent from './Line';
import ArcComponent from './Arc';
import PolylineComponent from './Polyline';
import TextComponent from './Text';
import PxcLogoComponent from './PxcLogo';

class PrimitiveRenderer extends React.Component {
  render() {
    const { primitiveType, ...restProps } = this.props;
    switch (primitiveType) {
      case 'rect':
        return <RectComponent {...restProps} />;
      case 'circle':
        return <CircleComponent {...restProps} />;
      case 'polygon':
        return <PolygonComponent {...restProps} />;
      case 'path':
        return <PathComponent {...restProps} />;
      case 'line':
        return <LineComponent {...restProps} />;
      case 'polyline':
        return <PolylineComponent {...restProps} />;
      case 'arc':
        return <ArcComponent {...restProps} />;
      case 'text':
        return <TextComponent {...restProps} />;
      case 'pxc_logo':
        return <PxcLogoComponent {...restProps} />;
      default:
        console.error('[PrimitiveRenderer] unknown primitive type: ', primitiveType);
        return null;
    }
  }
}

export default svgElementClickableListener(PrimitiveRenderer);
